<template>
  <div id="home">
      <Header></Header>
      <Banner :banners='bannerList' v-if="bannerList.length>0"></Banner>
      <div class="mask2" v-if="loading">
        <div class="sub">
          <img src="@/assets/img/Spinner-1s-50px.svg" alt="">
        </div>
      </div>
      <!-- 蒙版层 -->
      <div class="mask" v-if="show" @click="show = false">
        <img v-lazy="newData.indexQrcode" alt="">
      </div>

      <div class="y-video">
        <div class="video-title">
          <div class="video-text">
            BRAND VIDEO
            </div>
            <div class="video-name">
              伊享潮流
            </div>
          </div>
          <div class="video-img">
            <div class="img-title">
              <span class="line"></span>
              <router-link tag="span" to="/brandvideo" class="look-more">
                查看更多
              </router-link>
            <div class="videoInfo" >
              <video class="videoContainer" :src="newData.indexVideo" :poster="newData.indexImageVideo" controls="true" controlslist="nodownload" ></video>
            </div>
            <div class="line-bom"></div>
            </div>
          </div>
      </div>
       <router-link tag="div" to="/appreciate">
        <div class="y-video" >
          <div class="video-title">
            <div class="video-text">
              COLLECTIONS
              </div>
              <div class="video-name">
                伊品鉴赏
              </div>
            </div>
            <div class="video-img">
              <div class="img-title">
                <span class="line"></span>
                <span class="look-more">
                  了解更多最新款
                </span>
              <div class="videoInfo">
                  <img v-lazy="newData.indexImageProduct" alt="">
              </div>
              <div class="line-bom"></div>
              </div>
            </div>
        </div>
      </router-link>
      <router-link tag="div" to="/art">
        <div class="y-video" >
          <div class="video-title">
            <div class="video-text">
              ART  ENWEIS
              </div>
              <div class="video-name">
                艺术伊维斯
              </div>
            </div>
            <div class="video-img">
              <div class="img-title">
                <span class="line"></span>
                <span class="look-more">
                  品牌故事
                </span>
              <div class="videoInfo">
                <img v-lazy="newData.indexImageAbout" alt="">
              </div>
              <div class="line-bom"></div>
              </div>
            </div>
        </div>
      </router-link>

      <router-link tag="div" to="/artpainting">
         <div class="y-video ">
          <div class="video-title">
            <div class="video-text">
              BRA RESEARCH CENTER
              </div>
              <div class="video-name">
                艺术插画
              </div>
            </div>
            <div class="video-img">
              <div class="img-title">
                <span class="line"></span>
                <span class="look-more">
                  手绘欣赏
                </span>
              <div class="videoInfo">
                 <img v-lazy="newData.indexImageArt" alt="">
              </div>
              <div class="line-bom"></div>
              </div>
            </div>
        </div>
      </router-link>
      <router-link tag="div" to="/research">
        <div class="y-video " >
          <div class="video-title">
            <div class="video-text">
              ART ILLUSTRATION
              </div>
              <div class="video-name">
                内衣研究院
              </div>
            </div>
            <div class="video-img">
              <div class="img-title">
                <span class="line"></span>
                <span class="look-more">
                  研究领域
                </span>
              <div class="videoInfo">
                <img v-lazy="newData.indexImageResearch" alt="">
              </div>
              <div class="line-bom"></div>
              </div>
            </div>
        </div>
      </router-link>
      <router-link tag="div" to="/vipcenter">
        <div class="y-video ">
          <div class="video-title">
            <div class="video-text">
              VIP CLUB
              </div>
              <div class="video-name">
                会员中心
              </div>
            </div>
            <div class="video-img">
              <div class="img-title">
                <span class="line"></span>
                <span class="look-more">
                  会员章程
                </span>
              <div class="videoInfo">
                 <img v-lazy="newData.indexImageVIP" alt="">
              </div>
              <div class="line-bom"></div>
              </div>
            </div>
        </div>
      </router-link>
      <router-link tag="div" to="/storeimage">
        <div class="y-video ">
          <div class="video-title">
            <div class="video-text">
              ENWEIS SHOP
              </div>
              <div class="video-name">
                门店形象
              </div>
            </div>
            <div class="video-img">
              <div class="img-title">
                <span class="line"></span>
                <span class="look-more">
                  店铺分布
                </span>
              <div class="videoInfo">
                 <img v-lazy="newData.shopImage" alt="">
              </div>
              <div class="line-bom"></div>
              </div>
            </div>
        </div>
      </router-link>
      <div class="shopInfo">
        <router-link to="/yrstore"><img class="info-left" v-lazy="newData.tmallImage" alt=""></router-link>
        <img class="info-right" v-lazy="newData.indexQrcode" alt="" @click.stop="show = true">
      </div>
      <!-- 联系商家模块 -->
       <Concate></Concate>
  </div>
</template>
<script>
import Concate from '@/components/concatc/concatc';
import Banner from '@/components/bannerImg/banner';
import Header from '@/components/header/header.vue';
import $ from "jquery";
import CONSTANT from '@/constant/constant.js';
import common from '@/common.js';

new WOW().init();
export default {
  components: {
    Banner,
    Header,
    Concate,
  },
  data() {
    return{
      show: false,
      newData:{},
      bannerList:[],
      loading:true,
      contactData:null,
    }
  },
  methods: {
    // 超过可视区范围停止播放
    videoPlay() {
      $(window).scroll(function () {
      var scrollTop = $(document).scrollTop()
      if(scrollTop > '1800' || scrollTop < '200') {
        // 解决在别的页面不存在 video时报错的问题
        $('.videoContainer')[0] ? $('.videoContainer')[0].pause() : '';
      }
    });
    },
    // 获取首页数据
    getList() {
      console.log('首页调用');
      let url = CONSTANT.INDEX.INDEXDATA;
      common.postNoSess(url, null,null, res => {
        let data = res.data.bussData;
        this.newData = data;
        this.bannerList = data.banners;
        sessionStorage.setItem('contact',JSON.stringify(data.contact));
        this.loading = false;
      });
    },
  },
  created(){
    this.getList();
    this.videoPlay();
  }
}
</script>

<style lang="less">
@import url('./home.less');
</style>
